import { render, staticRenderFns } from "./TableResumenPaquete.vue?vue&type=template&id=b1b8e538&scoped=true"
import script from "./TableResumenPaquete.vue?vue&type=script&lang=js"
export * from "./TableResumenPaquete.vue?vue&type=script&lang=js"
import style0 from "./TableResumenPaquete.vue?vue&type=style&index=0&id=b1b8e538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b8e538",
  null
  
)

export default component.exports